{
    "title": "Legal Information",
    "input":{
        "nationality": "Country of Residence",
        "taxReferenceNumber": "Tax Identification Number (TIN)",
        "passportNumber": "Passport Number",
        "citizenship": "Citizenship"
    }
}